import { render, staticRenderFns } from "./microphone.vue?vue&type=template&id=8f38d14e&scoped=true&"
var script = {}
import style0 from "./microphone.vue?vue&type=style&index=0&id=8f38d14e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f38d14e",
  null
  
)

export default component.exports